/**
 *
 * @param productId<String>
 * @param sceneType<String>
 * @param ticketData<Array>
 * @returns {*}
 */
export function filterTicketWithProduct (productId, sceneType, ticketData) {
  return ticketData.filter(item => {
    return item['productIds'].includes(productId) && item['sceneType'] === sceneType
  })
}

export function filterCouponWithProductId (productId, couponData) {
  let list = couponData.filter(item => {
    return item['productIds'].includes(productId)
  })
  // if (list.length > 0) {
  //   list.unshift({ couponDesc: '未选择', value: '', price: 0 })
  // }
  return list
}

export function filterTicketCommon (sceneType, ticketData) {
  return ticketData.filter(item => {
    return item['productFlag'] === 0 && item['sceneType'] === sceneType
  })
}
